import { render, staticRenderFns } from "./TrainerFightWinNext.vue?vue&type=template&id=6e06048d&scoped=true"
import script from "./TrainerFightWinNext.vue?vue&type=script&lang=js"
export * from "./TrainerFightWinNext.vue?vue&type=script&lang=js"
import style0 from "./TrainerFightWinNext.vue?vue&type=style&index=0&id=6e06048d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e06048d",
  null
  
)

export default component.exports